import { render, staticRenderFns } from "./GarageDoorSizeAndMotorization.vue?vue&type=template&id=31de497f&scoped=true"
import script from "./GarageDoorSizeAndMotorization.vue?vue&type=script&lang=ts"
export * from "./GarageDoorSizeAndMotorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de497f",
  null
  
)

export default component.exports